module.exports = __webpack_public_path__ + "static/media/darkSubscription.92820ca5.svg";